import CryptoJS from "crypto-js";

const SECRET_KEY = "VIKHzXPvUS58fIXWiIXJsxZem3dp6nFt"; // keep 32 chars for AES-256

export const encrypt = (data) => {
  const ciphertext = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    SECRET_KEY
  ).toString();

  return encodeURIComponent(ciphertext); // safe for URL
};

export const decrypt = (ciphertext) => {
  const bytes = CryptoJS.AES.decrypt(
    decodeURIComponent(ciphertext),
    SECRET_KEY
  );
  const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

  return JSON.parse(decryptedData);
};

export const safeDecrypt = (searchParams, key) => {
  const val = searchParams.get(key);
  if (!val) return null;
  try {
    return decrypt(val);
  } catch (err) {
    console.warn(`Failed to decrypt ${key}:`, err);
    return null;
  }
};
